<mat-card class="pnf-container">
  <mat-card-title>Page Not Found</mat-card-title>
  <mat-card-subtitle>Error 404</mat-card-subtitle>
  <mat-card-content>
    <p>The page you were looking for could not be found. Please check the url you have entered.</p>
  </mat-card-content>
  <mat-card-actions>
    <button color="primary" routerLink="/" mat-raised-button>DASHBOARD</button>
  </mat-card-actions>
</mat-card>
